import { OrderType } from '../../../smoothr-web-app-core/enums/OrderType';
import { getPrice, getSlotsByOrder, numberD } from '../../../smoothr-web-app-core/utils/utils';
import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild, signal, AfterViewInit} from '@angular/core';
import { IonContent, ModalController, PickerController } from '@ionic/angular';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import * as moment from 'moment';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Moment } from 'moment';
import { ValidationUtils } from '../../../smoothr-web-app-core/utils/validation-utils';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { Router } from '@angular/router';
import { calculateGeoDistance, MapsUtils } from '../../../smoothr-web-app-core/utils/maps-utils';
import { isVenueOpen, numberToCurrency } from '../../../smoothr-web-app-core/utils/utils';
import Order from '../../../smoothr-web-app-core/models/Order';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { TimeUtils } from '../../../smoothr-web-app-core/utils/time-utils';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from 'src/smoothr-web-app-core/models/ArticleOption';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import { environment } from 'src/environments/environment';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {CompressedStorageService} from '../../../smoothr-web-app-core/services/compression';
import {HelloAgainService} from '../../services/hello-again.service';

export enum checkoutPaymentType {
	NOW = 'now',
	LATER = 'later',
	CASH = 'cash',
}
@Component({
	selector: 'app-checkout-modal',
	templateUrl: './checkout-modal.component.html',
	styleUrls: ['checkout-modal.component.scss'],
})
export class CheckoutModalComponent extends RepositoryDirective implements OnInit, AfterViewInit {
	orderUtils = OrderUtils;
	loading = false;
	now: moment.Moment;
	pt = PreorderType;
	streetNumberError: string;
	orderAtError: string;
	streetError: string;
	postalCodeError: string;
	hadPostalCode = false;
	isVenueOpen = false;
	tip: number = 0;
	amiciPoints: number = 0;

	orderForm: FormGroup;
	name = 'name';
	email = 'email';
	phone = 'phone';
	note = 'note';
	orderAt = 'orderAt';

	numberToCurrency = numberToCurrency;
	slots: Moment[] = [];
	environment = environment;

	@ViewChild(IonContent, { static: false }) content;
	@ViewChild('swiperCheckout', { static: false }) slides;
	slideOptions = {
		spaceBetween: 0,
		initialSlide: 0,
		speed: 400,
		allowTouchMove: false,
	};
	isOverviewPage = false;
	@Output() closedDialog = new EventEmitter<void>();
	street = 'street';
	city = 'city';
	postalCode = 'postalCode';

	number = 'number';
	totalPriceValue: string = '';
	totalPriceNumber = 0;
	mappedOrderArticlesValue: ArticleGroup[] = [];

	public selectAgb = signal<boolean>(false);
	public startLighting = signal<boolean>(false);

	checkoutPaymentType = checkoutPaymentType;

	constructor(
		private modalCtrl: ModalController,
		protected repository: RepositoryService,
		private snackbarCtrl: MatSnackBar,
		private pickerCtrl: PickerController,
		private translate: TranslateService,
		private analytics: AnalyticsService,
		private cdr: ChangeDetectorRef,
		private fb: FormBuilder,
		public helloAgainService: HelloAgainService
	) {
		super(repository);
		if (this.address && this.address.postalCode && this.address.postalCode.length > 0) {
			this.hadPostalCode = true;
		}
		if (this.order && this.order.preorder && this.order.preorder.postalCode && this.address.postalCode.length > 0) {
			this.hadPostalCode = true;
		}
	}
	// ngAfterViewInit(): void {
	// 	this.toOverview(); //TODO: to remove;
	// }
	get selectedAgb() {
		return this.selectAgb();
	}
	static async show(modalCtrl: ModalController, analytics: AnalyticsService, order: Order, tip: number) {
		const modal = await modalCtrl.create({
			component: CheckoutModalComponent,
			componentProps: {
				tip,
			},
			showBackdrop: true,
			backdropDismiss: true,
			cssClass: 'item-modal-checkout',
		});
		await modal.present();
		analytics.beginCheckout(order);
		return await modal.onDidDismiss();
	}

	ngOnInit() {
		super.ngOnInit();

		if (this.helloAgainService.isUserRedirectedFromHelloAgain) {
			this.slideOptions.initialSlide = 1;
		}

		this.analytics.checkoutProgress(this.order, null, 1);
		this.analytics.customerBeginsCheckout();
		this.createOrderForm();

		this.checkPrevOrder();
		this.loadSlots();
		this.totalPrice();
		this.mappedOrderArticlesValue = this.order.orderedArticles.map(it => {
			it = this.mapGroup(it);
			return it;
		});

		this.amiciPoints = Math.ceil(this.totalPriceNumber);
	}

	ngAfterViewInit() {
		if (this.helloAgainService.isUserRedirectedFromHelloAgain) {
			this.toOverview();
			this.helloAgainService.finishRedirectProcess();
		}
	}

	onOrder() {
		super.onOrder();
		const postalCodeInOrder =
			this.order && this.order.preorder && this.order.preorder.postalCode && this.order.preorder.postalCode.length > 0;
		this.cdr.detectChanges();
		this.totalPrice();
		// Fix: Update cart display when order changes to keep checkout modal in sync
		if (this.order && this.order.orderedArticles) {
			this.mappedOrderArticlesValue = this.order.orderedArticles.map(it => {
				it = this.mapGroup(it);
				return it;
			});
		}
	}

	checkPrevOrder() {
		if (this.order && this.order.preorder) {
			if (this.repository._previousPreorder) {
				this.orderForm.patchValue({
					name: this.repository._previousPreorder?.name ?? '',
					email: this.repository._previousPreorder?.email ?? '',
					phone: {
						country: '+49',
						phone: this.repository._previousPreorder?.phone?.trim().replace('+49', ''),
					},
				});
			}
		}
	}

	onAddress() {
		super.onAddress();
		this.hadPostalCode = this.hadPostalCode || (this.address && this.address.postalCode && this.address.postalCode.length > 0);
	}

	onCustomer() {
		super.onCustomer();
		if (this.customer) {
			if (this.customer.postalCode && this.customer.postalCode.length > 0) {
				this.hadPostalCode = true;
			}
			if (!this.order.preorder.email) {
				this.order.preorder.email = this.customer.email;
			}
			if (!this.order.preorder.name) {
				this.order.preorder.name = this.customer.name;
			}
			if (!this.order.preorder.companyName) {
				this.order.preorder.companyName = this.customer.companyName;
			}
			if (!this.order.preorder.phone) {
				this.order.preorder.phone = this.customer.phone;
			}
			if (!this.order.preorder.floor) {
				this.order.preorder.floor = this.customer.floor;
			}
			if (!this.order.preorder.subcard) {
				this.order.preorder.subcard = this.customer.subcard;
			}
			if (this.order.preorder.type === PreorderType.DELIVERY) {
				if (!this.order.preorder.street) {
					this.order.preorder.street = this.customer.street;
				}
				if (!this.order.preorder.postalCode) {
					this.order.preorder.postalCode = this.customer.postalCode;
				}
				if (!this.order.preorder.city) {
					this.order.preorder.city = this.customer.city;
				}
				if (!this.order.preorder.number && this.order.preorder.street === this.customer.street) {
					this.order.preorder.number = this.customer.number;
				}
			}
		}
	}

	checkCustomer() {
		console.log(this.customer);
		if (this.customer) {
			if (this.customer?.name) {
				console.log('HERE', this.customer.name.split(' '));
				this.orderForm.patchValue({
					name: this.customer.name.split(' ')[0],
					surname: this.customer?.name.replace(this.customer.name.split(' ')[0], ''),
				});
			}
			if (this.customer?.email) {
				this.orderForm.patchValue({
					email: this.customer?.email,
				});
			}
			if (this.customer?.phone) {
				this.orderForm.patchValue({
					phone: {
						internationalNumber: this.customer?.phone ?? '',
						dialoCode: '+49',
						isoCode: 'de',
						nationalNumber: this.customer?.phone.trim().replace('+49', ''),
					},
				});
			}
		}
	}

	async openTimeSheet() {
		if (!this.venue) {
			this.snackbarCtrl.open(this.translate.instant('errors.venue'), null, {
				duration: 2000,
			});
			return;
		}
		if (this.loading) {
			return;
		}
		this.loading = true;
		try {
			let slots = await getSlotsByOrder(this.venue, this.order);
			if (slots.length === 0) {
				this.loading = false;
				this.snackbarCtrl.open(this.translate.instant('checkout_modal.no_slots'), null, {
					duration: 2000,
				});
				return;
			}
			// ASAP option removed: customers must explicitly pick a slot so cut-off / prep-buffer rules are enforced.
			const options = {
				columns: [
					{
						name: 'slot',
						class: 'time-picker',
						options: slots.map(slot => {
							return {
								text: this.slotToText(slot ? moment(slot.time) : null),
								value: slot,
							};
						}),
					},
				],
				buttons: [
					{
						text: this.translate.instant('checkout_modal.cancel'),
						role: 'cancel',
					},
					{
						text: this.translate.instant('checkout_modal.confirm'),
						handler: value => {
							const slot = value.slot.value;
							if (!slot) {
								this.order.asap = false;
								this.order.orderAt = null;
								return;
							}
							const conflictingArticles = OrderUtils.slotConflictingArticlesInOrder(moment(slot.time), this.order);
							if (conflictingArticles.length > 0) {
								this.snackbarCtrl.open(
									this.translate.instant('checkout_modal.products_unavailable') +
										conflictingArticles
											.map(conflictingArticle => conflictingArticle.article.name.de)
											.reduce((previousValue, currentValue) => previousValue + ' ' + currentValue),
									null,
									{
										duration: 3000,
									}
								);
								return;
							}
							this.order.orderAt = moment(slot.time).local();
						},
					},
				],
			};
			const picker = await this.pickerCtrl.create(options);

			await picker.present();
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('checkout_modal.time_error'), null, {
				duration: 2000,
			});
			console.error(e);
		}
		this.loading = false;
	}

	async close(paymentType: checkoutPaymentType) {
		await this.updateForm();

		const data = {
			preorder: this.order.preorder,
			orderAt: this.getFormControlValue('orderAt'),
			tip: this.tip,
			asap: this.order.asap,
			paymentType,
		};
		this.repository.previousPreorder.emit(this.order.preorder);

		await this.modalCtrl.dismiss(data);
	}

	async updateForm() {
		this.order.preorder.name = this.getFormControlValue('name');
		if (this.getFormControlValue('phone')?.phone && this.getFormControlValue('phone')?.country)
			this.order.preorder.phone = this.getFormControlValue('phone')?.country + this.getFormControlValue('phone')?.phone;
		this.order.preorder.email = this.getFormControlValue('email');
		this.order.note = this.getFormControlValue('note');
		if (this.getFormControlValue('orderAt')) {
			this.order.orderAt = this.getFormControlValue('orderAt');
		} else {
			this.order.orderAt = null;
		}
		// ASAP is no longer offered — orders must always carry an explicit orderAt.
		this.order.asap = false;
		if (this.order.preorder.type === PreorderType.DELIVERY) {
			this.order.preorder.city = this.getFormControlValue('city');
			this.order.preorder.postalCode = this.getFormControlValue('postalCode');
			this.order.preorder.number = this.getFormControlValue('number');
			this.order.preorder.street = this.getFormControlValue('street');
		}
		this.repository.onOrderChange(this.order);
	}
	async dismiss() {
		await this.modalCtrl.dismiss();
	}

	slotToText(slot: Moment): string {
		if (!slot) {
			return this.translate.instant('checkout_modal.choose_slot');
		}
		const slotMoment = moment(slot);
		const sameDay = TimeUtils.isSameDate(slotMoment, moment());
		if (sameDay) {
			return slotMoment.format('HH:mm');
		} else {
			return slotMoment.format('DD.MM. HH:mm');
		}
	}

	onVenue() {
		this.isVenueOpen = isVenueOpen(this.venue);
	}

	onVenueError(error) {
		super.onVenueError(error);
		this.isVenueOpen = false;
		if (this.order) {
			this.order.asap = false;
		}
	}

	async submitFormCustomValidator(touchAllElements: boolean): Promise<boolean> {
		if (touchAllElements) {
			for (let controlsKey in this.orderForm.controls) {
				this.orderForm.controls[controlsKey].markAsTouched();
			}
		}
		if (!this.isFormValid()) {
			return false;
		}
		let controlStreetValue = (this.getFormControlValue('street') ?? '').trim();
		let controlHouseNumberValue = (this.getFormControlValue('number') ?? '').trim();
		let controlPostalCodeValue = (this.getFormControlValue('postalCode') ?? '').trim();
		let controlCityValue = (this.getFormControlValue('city') ?? '').trim();
		if (
			OrderUtils.isDelivery(this.order) &&
			(controlStreetValue !== this.address.street ||
				controlPostalCodeValue !== this.address.postalCode ||
				controlCityValue !== this.address.city ||
				controlHouseNumberValue !== this.address.number)
		) {
			try {
				const pred = controlStreetValue + ' ' + controlHouseNumberValue + ', ' + controlCityValue + ' ' + controlPostalCodeValue;
				const geocode = await MapsUtils.getPlace(pred);
				const address = MapsUtils.placeToAddress(geocode);
				const addressValidationResult = ValidationUtils.validateAddress(address, true);
				if (addressValidationResult) {
					// this.streetError = this.translate.instant(addressValidationResult);
					this.orderForm.controls['street'].setErrors({ incorrect: true });
					return false;
				}
				const delivers =
					(this.venue.deliveryByRadius &&
						calculateGeoDistance(
							address.lat,
							address.lng,
							this.venue.location.coordinates[1],
							this.venue.location.coordinates[0]
						) <= this.venue.deliveryRadius) ||
					(this.venue.isPostalDelivery && this.venue.deliveryPostalCodes.indexOf(address.postalCode));
				if (!delivers) {
					this.orderForm.controls['street'].setErrors({ street_delivery: true });

					this.snackbarCtrl.open(this.translate.instant('errors.street_delivery'), null, {
						duration: 2000,
					});
					return false;
				}
				this.repository.address.emit(address);
				this.orderForm.patchValue({
					street: this.address.street,
				});
				return true;
			} catch (e) {
				this.orderForm.controls['street'].setErrors({ street_not_found: true });
				this.snackbarCtrl.open(this.translate.instant('errors.street_not_found'), null, {
					duration: 2000,
				});
				return false;
			}
		} else {
			return true;
		}
	}
	hiddenInCart(article: Article): boolean {
		return article.tags && article.tags.find(tag => tag.identifier === 'hide_cart') !== undefined;
	}
	reloadAddress() {
		if (this.order && this.order.preorder && this.address && this.order.preorder.type === PreorderType.DELIVERY && this.orderForm) {
			this.orderForm.patchValue({
				city: this.address?.city ?? '',
				street: this.address?.street ?? '',
				postalCode: this.address?.postalCode && this.address?.postalCode?.length > 0 ? this.address.postalCode : '',
				country: this.address?.country,
				number: this.address?.number,
			});
		}
	}
	async onButtonClick() {
		if (this.loading) {
			return;
		}
		this.loading = true;
		let willDismiss = false;
		try {
			if (!(await this.submitFormCustomValidator(true)) && !this.isOverviewPage) {
				return;
			}

			if (!this.isOverviewPage) {
				this.startLighting.set(false);
				if (this.selectedAgb) {
					await this.toOverview();
				} else {
					this.performScroll();
				}
			} else {
				willDismiss = true;
				await this.close(checkoutPaymentType.NOW);
			}
		} finally {
			if (!willDismiss) {
				this.loading = false;
			}
		}
	}


	private performScroll() {
		// Use timeout to ensure DOM is ready
		setTimeout(() => {
			// Try direct selectors since AGB elements are not inside swiper slides
			const agbRadioElement = document.querySelector('ion-radio-group ion-radio');
			const wrapperElement = document.querySelector('.wrapper-send-letter');
			
			if (agbRadioElement) {
				agbRadioElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
			} else if (wrapperElement) {
				wrapperElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
			} else if (this.content) {
				// Final fallback: scroll content to bottom
				this.content.scrollToBottom(400);
			}

			this.startLighting.set(true);
		}, 200);
	}


	async toOverview() {
		// await this.slides.update();
		await this.slides.nativeElement.swiper.slideNext();
		console.log('Slide next');
		this.isOverviewPage = true;
	}
	async editPersonalData() {
		await this.slides.nativeElement.swiper.slidePrev();
		this.isOverviewPage = false;
	}
	slotSelected($event) {
		this.order.orderAt = $event;
		this.order.asap = false;
	}
	async backOrDismiss() {
		if (this.isOverviewPage) {
			await this.editPersonalData();
		} else {
			await this.dismiss();
		}
	}
	async loadSlots() {
		this.slots = [];
		this.order.orderAt = null;
		console.log('LOAD SLOTS', this.venue, this.order);
		if (!this.venue) {
			this.snackbarCtrl.open(this.translate.instant('errors.venue'), null, {
				duration: 2000,
			});
			return;
		}
		// if (this.loading) {
		// 	return;
		// }
		this.loading = true;
		try {
			// Refetch the venue so latest opening hours / offsets (e.g. closing time, last-order
			// offset) edited in the dashboard are honored before computing pickup slots.
			try {
				const refreshed = await this.repository.getVenue(this.venue._id, true);
				if (refreshed) {
					this.venue = refreshed;
				}
			} catch (e) {
				console.error('Failed to refresh venue before loading slots', e);
			}
			const daysToCalculate = this.venue?.slot?.daysToCalculate ?? 7;
			this.slots = (await getSlotsByOrder(this.venue, this.order, 0, false, daysToCalculate)).map(slot => moment(slot.time));
			console.log('THIS sLots', this.slots);
			if (this.slots.length === 0) {
				this.loading = false;
				this.snackbarCtrl.open(this.translate.instant('checkout_modal.no_slots'), null, {
					duration: 2000,
				});
				return;
			}

			// this.slots = [null, ...this.slots];
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('checkout_modal.time_error'), null, {
				duration: 2000,
			});
			console.error(e);
		}
		this.loading = false;
	}
	priceOfOption(articleGroup: ArticleGroup, articleOption: ArticleOption): number {
		const price = getPrice(articleOption.article, OrderType.PREORDER, this.order.preorder.type);
		if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && articleGroup.isPromo) {
			return 0;
		}
		if (articleGroup) {
			const findGroup = articleGroup.article.groups.find(it => it._id === articleOption.group);
			if (findGroup) {
				if (findGroup.tags.find(it => it.identifier === 'half_pizza')) {
					return 0;
				}
			}
		}
		return price * articleOption.quantity;
	}
	createOrderForm() {
		const formControlNames: any = {};

		formControlNames[this.name] = ['', [Validators.required, Validators.pattern(/^.+\s.+$/)]];

		formControlNames[this.email] = [
			'',
			[
				Validators.required,
				Validators.pattern(
					"^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
				),
			],
		];

		formControlNames[this.phone] = ['', [Validators.required, this._customPhoneValidatorForLibrary]];

		formControlNames[this.note] = [this.order?.note || '', []];

		formControlNames[this.orderAt] = ['', [Validators.required]];
		if (this.order.preorder.type === PreorderType.DELIVERY) {
			formControlNames[this.street] = ['', [Validators.required]];
			formControlNames[this.city] = ['', [Validators.required]];
			formControlNames[this.postalCode] = ['', [Validators.required]];
			formControlNames[this.number] = ['', [Validators.required]];
		}
		this.orderForm = this.fb.group(formControlNames);

		// Disable the address fields that should be read-only
		if (this.order.preorder.type === PreorderType.DELIVERY) {
			this.orderForm.get('street')?.disable();
			this.orderForm.get('number')?.disable();
			this.orderForm.get('postalCode')?.disable();
			this.orderForm.get('city')?.disable();
		}

		this.checkCustomer();
		this.reloadAddress();
	}

	private _customPhoneValidatorForLibrary(control: AbstractControl) {
		if (!control.value?.phone) {
			return { required: true };
		}

		// Check if phone contains only digits
		const phoneDigits = control.value.phone.toString();
		if (!/^\d+$/.test(phoneDigits)) {
			return { invalidPhone: true };
		}

		const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
		try {
			const phoneNumber = phoneUtil.parse(control?.value?.country + phoneDigits);
			if (phoneUtil.isValidNumber(phoneNumber) && phoneUtil.isPossibleNumber(phoneNumber)) {
				return null;
			} else {
				return { invalidPhone: true };
			}
		} catch (e) {
			return { invalidCountryCode: true };
		}
	}

	getFormControlValue(controlName?: string) {
		if (controlName) {
			return this.orderForm.get(controlName)?.value;
		}
		return '';
	}
	isValid(controlName?: string): boolean {
		if (controlName) {
			return this.orderForm?.get(controlName)?.hasError('required') && this.orderForm?.get(controlName)?.touched;
		}
		return this.orderForm?.invalid;
	}

	isValidByPattern(controlName?: string): boolean {
		if (controlName) {
			return this.orderForm?.get(controlName)?.errors && !this.orderForm?.get(controlName)?.hasError('required');
		}
		return this.orderForm.invalid;
	}

	getErrorsForm(controlName) {
		if (controlName) {
			return this.orderForm.get(controlName).errors;
		}

		return null;
	}

	private _customPhoneValidator(control: AbstractControl) {
		const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
		try {
			const phoneNumber = phoneUtil.parse(control?.value);
			if (phoneUtil.isValidNumber(phoneNumber) && phoneUtil.isPossibleNumber(phoneNumber)) {
				return null;
			} else {
				return { invalidPhone: true };
			}
		} catch (e) {
			return { invalidCountryCode: true };
		}
	}

	public handleChangeRadio(event: any): void {
		if (event.detail.value) {
			this.selectAgb.set(!!event.detail.value);
		} else {
			this.selectAgb.set(false);
		}
	}

	public onConsentLinkClick(path: string, event: Event): void {
		event.preventDefault();
		event.stopPropagation();
		window.open(path, '_blank');
	}
	totalPrice() {
		console.log('BEFORE MAP', this.order, this.venue);

		if (this.venue) {
			const foundArticleIndex = this.order.orderedArticles.findIndex(it => it.isHalfPizza);
			if (foundArticleIndex >= 0) {
				console.log('here before calc');
				const foundArticle = this.venue.articleCategories
					.map(it => it.articles.find(ar => ar.tags.find(tag => tag.identifier == 'appliesMostExpensive')))
					.filter(it => !!it);
				console.log(foundArticle);
				if (foundArticle.length > 0) {
					let mappedOrder = JSON.parse(JSON.stringify(this.order));
					mappedOrder.orderedArticles = mappedOrder.orderedArticles.map(it => {
						if (it.isHalfPizza) {
							it.article = foundArticle[0];
						}
						return it;
					});
					this.totalPriceNumber = OrderUtils.orderTotalPrice(mappedOrder, true, true)
					this.totalPriceValue = numberToCurrency(
						this.totalPriceNumber + this.tip,
						this.order.currency
					);
					// Fix: Update cart display for consistency after total calculation
					if (this.order && this.order.orderedArticles) {
						this.mappedOrderArticlesValue = this.order.orderedArticles.map(it => {
							it = this.mapGroup(it);
							return it;
						});
					}
					return;
				}
			}
		}
		this.totalPriceNumber = OrderUtils.orderTotalPrice(this.order, true, true)
		this.totalPriceValue = numberToCurrency(this.totalPriceNumber + this.tip, this.order.currency);

		// Fix: Always update cart display when total is recalculated
		if (this.order && this.order.orderedArticles) {
			this.mappedOrderArticlesValue = this.order.orderedArticles.map(it => {
				it = this.mapGroup(it);
				return it;
			});
		}
	}
	changeTip(tip: number) {
		this.tip = tip;
		this.totalPrice();
	}

	checkPriceArticle(articleGroup: ArticleGroup, orderType: OrderType, preorderType: PreorderType) {}
	mapGroup(articleGroup: ArticleGroup) {
		console.log('MapGroup');
		if (!this.venue || !this.order) {
			return articleGroup;
		}
		if (this.venue) {
			const foundArticle = this.venue.articleCategories
				.map(it => {
					if (it.visible) {
						const foundArticle = it.articles.find(ar => ar._id === articleGroup.article._id);

						return foundArticle ?? null;
					} else {
						return null;
					}
				})
				.filter(it => !!it);
			if (foundArticle.length === 1) {
				const test = JSON.parse(JSON.stringify(articleGroup)) as ArticleGroup;
				test.article = JSON.parse(JSON.stringify(foundArticle[0]));

				return test;
			}
			return articleGroup;
		}
		return articleGroup;
	}
	calculateTotalPriceOfArticle(oa: ArticleGroup, orderType: OrderType, preorderType: PreorderType) {
		if (this.order && this.order?.preorder) {
			let totalPriceOfOA = OrderUtils.totalPrice(oa, orderType, preorderType);
			if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && oa.isPromo) {
				const price = OrderUtils.bogoPrice(oa, this.order.type, this.order.preorder.type);
				if (oa.freeArticle) {
					// Free-article promos zero out the article price, but any Pfand (deposit)
					// is still charged and added to the order total via totalPricePfandPrize.
					// Surface that deposit on the line item so the breakdown reconciles with
					// the total instead of showing 0,00 €.
					const pfand =
						OrderUtils.totalPricePfandPrize(oa, this.order.type, this.order.preorder.type) * oa.quantity;
					totalPriceOfOA = numberD(oa.article.price) - price + pfand;
				} else totalPriceOfOA -= price;
			}
			// The article price includes the deposit meta field; the overview shows the base
			// price and lists the deposit separately. The sum keeps the full amount.
			totalPriceOfOA -= OrderUtils.fieldDepositOfLine(oa);
			return numberToCurrency(totalPriceOfOA, this.order.currency);
		} else {
			return '';
		}
	}
	isFormValid() {
		return this.orderForm?.valid;
	}

	protected readonly PreorderType = PreorderType;
}
